export const LANG_KEY = "lang";

export function getLang() {
  return localStorage.getItem(LANG_KEY) || "en";
}

export function setLang(lang) {
  localStorage.setItem(LANG_KEY, lang);
}

export function pickLang(obj, keyBase, lang) {
  // Ex: keyBase="title" => title_en / title_kn
  if (!obj) return "";
  const v = lang === "kn" ? obj[`${keyBase}_kn`] : obj[`${keyBase}_en`];
  return v || (lang === "kn" ? obj[`${keyBase}_en`] : obj[`${keyBase}_kn`]) || "";
}
